export const checklistsBottomItem = {
  icon: 'assets/svg/checkbox-outline.svg',
  activeIcon: 'assets/svg/checkbox-outline.svg',
  label: 'Checklists',
  target: '/to-dos',
};

export const bottomMenuItems = [
  {
    icon: 'assets/img/agent-white.svg',
    activeIcon: 'assets/img/agent-white.svg',
    label: 'Chat',
    target: '/chat',
  },
  {
    icon: 'assets/svg/grid-outline.svg',
    activeIcon: 'assets/svg/grid-outline.svg',
    label: 'Overview',
    target: '/overview',
  },
  {
    icon: 'assets/svg/wallet-outline.svg',
    activeIcon: 'assets/svg/wallet-outline.svg',
    label: 'Income',
    target: '/overview',
  },
  {
    icon: 'assets/svg/build-outline.svg',
    activeIcon: 'assets/svg/build-outline.svg',
    label: 'Maintenance',
    target: '/maintenance',
  },
  {
    icon: 'assets/img/menu-schedule-white.svg',
    activeIcon: 'assets/img/menu-schedule-green.svg',
    label: 'Schedule',
    target: '/schedule',
  },
  {
    icon: 'assets/svg/chatbubbles-outline.svg',
    activeIcon: 'assets/svg/chatbubbles-outline.svg',
    label: 'Messages',
    target: '/messages',
  },
  {
    icon: 'assets/svg/ellipsis-horizontal-outline.svg',
    activeIcon: 'assets/svg/ellipsis-horizontal-outline.svg',
    label: 'More',
    target: '/more'
  }
];

// Rental-only tabs used by the rental variant of the bottom nav: "Overview" is
// the P&L page and "Properties" is the property list dashboard. Icons match
// what the desktop nav uses for the same destinations — `grid-outline.svg` is
// the desktop "Overview" sub-item icon under the Finance section, and
// `home-outline.svg` is the desktop Properties button icon.
export const rentalOverviewItem = {
  icon: 'assets/svg/grid-outline.svg',
  activeIcon: 'assets/svg/grid-outline.svg',
  label: 'Overview',
  target: '/overview',
};

export const rentalPropertiesItem = {
  // Matches the desktop nav's Properties button which uses home-outline.svg.
  icon: 'assets/svg/home-outline.svg',
  activeIcon: 'assets/svg/home-outline.svg',
  label: 'Properties',
  target: '/properties',
};
